import { Box, Button, Typography } from '@mui/material';
import { useId, useState } from 'react';

interface ExpandableTextProps {
    text?: string | null;
    maxChars?: number;
    emptyText?: string;
}

const truncateAtWord = (text: string, maxChars: number) => {
    const cut = text.slice(0, maxChars);
    const lastSpace = cut.search(/\s\S*$/);
    return `${(lastSpace > maxChars * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
};

const ExpandableText = ({ text, maxChars = 280, emptyText = '—' }: ExpandableTextProps) => {
    const [expanded, setExpanded] = useState(false);
    const contentId = useId();
    const value = text?.trim() ?? '';
    const long = value.length > maxChars;

    if (!value) {
        return <Typography variant='body2' color='text.disabled'>{emptyText}</Typography>;
    }

    return (
        <Box>
            <Typography id={contentId} variant='body2' component='div' sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                {long && !expanded ? truncateAtWord(value, maxChars) : value}
            </Typography>
            {long && (
                <Button
                    size='small'
                    aria-expanded={expanded}
                    aria-controls={contentId}
                    onClick={() => setExpanded(open => !open)}
                    sx={{ px: 0, mt: 0.5, minWidth: 0 }}
                >
                    {expanded ? 'Show less' : 'Show more'}
                </Button>
            )}
        </Box>
    );
};

export default ExpandableText;
